import { Alert } from 'antd';
import { isErrored, isFailed, isReceived, isRequested } from '@sonar-software/xuder';
import React, { useMemo, useState } from 'react';
import { useAsyncProcessing } from '@hooks';
function getAlertOptions(options) {
    if (typeof options === 'string') {
        return {
            message: options
        };
    }
    return options;
}
function getNotificationType(status) {
    const stateStatus = status;
    switch (true) {
        case isRequested(stateStatus):
            return 'info';
        case isErrored(stateStatus):
        case isFailed(stateStatus):
            return 'error';
        case isReceived(stateStatus):
            return 'success';
        default:
            return 'error';
    }
}
export const AsyncStateAlert = ({ byStatusCode, errored, failed, received, requested, stateSelector }) => {
    const [alert, setAlert] = useState(null);
    const statusCodeHandlers = useMemo(() => byStatusCode === null || byStatusCode === void 0 ? void 0 : byStatusCode.reduce((codes, entry) => {
        codes[entry.statusCode] = entry.options;
        return codes;
    }, {}), [byStatusCode]);
    useAsyncProcessing({
        allowMultipleHandlers: false,
        onStatus: (status, options) => {
            if (options) {
                setAlert(React.createElement(Alert, Object.assign({ type: getNotificationType(status) }, getAlertOptions(options !== null && options !== void 0 ? options : ''))));
            }
        },
        onStatusCode: (_, options) => {
            if (options) {
                setAlert(React.createElement(Alert, Object.assign({}, options)));
            }
        },
        stateSelector,
        statusCodeHandlers,
        statusHandlers: {
            errored: getAlertOptions(errored),
            failed: getAlertOptions(failed),
            received: getAlertOptions(received),
            requested: getAlertOptions(requested)
        },
        watchAllCalls: true
    });
    return alert;
};
